<template>
  <v-footer
    class="pa-5"
    style="background: linear-gradient(50.5deg, #ffffffff 27.9%, #c4c4c4ff 84.2%)"
  >
    <v-container>
      <v-row>
        <!-- Logo and Address Section -->
        <v-col cols="12" md="4">
          <!-- <v-img
            :src="require('@/assets/logo-provalue.png')"
            max-width="220"
            min-width="150"
            class="mb-5"
          ></v-img> -->
          <p style="color: #45009fff; font-size: 12px; margin: 0">
            Unit 401 Victoria Towers, #79 Panay Ave, Cor. Timog Ave.
          </p>
          <p style="color: #45009fff; font-size: 12px; margin: 0">
            Brgy. Paligsahan, Quezon City, Metro Manila, Philippines
          </p>
          <p style="color: #45009fff; font-size: 12px; margin-top: 5px">
            xxxxxxx@workforce.xxx.xx
          </p>
          <p style="color: #45009fff; font-size: 12px; margin-top: 5px">+639XXXXXXXXX</p>

          <div class="my-5">
            <v-btn
              v-for="icon in icons"
              :key="icon.title"
              :icon="icon.title"
              :color="icon.color"
              class="align-start"
              variant="text"
            ></v-btn>
          </div>
        </v-col>

        <!-- Frequently Asked Questions Section -->
        <v-col cols="12" md="4">
          <h5 class="font-weight-bold mb-4" style="color: #45009fff">
            Frequently Asked Questions
          </h5>
          <v-list dense class="bg-transparent" style="color: #45009fff">
            <v-list-item
              v-for="(item, index) in faqs"
              :key="index"
              style="color: #45009fff"
            >
              <v-list-item-title style="font-size: 12px">
                <v-icon small class="me-2" style="color: #45009fff"
                  >mdi-chevron-right</v-icon
                >
                {{ item }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>

        <!-- Newsletter Section -->
        <v-col cols="12" md="4">
          <h5 class="font-weight-bold mb-6" style="color: #45009fff">Newsletter</h5>
          <p style="color: #45009fff; font-size: 12px" class="mb-5">
            We may send you information about related events, webinars, products, and
            services which we think you'll find interesting.
          </p>
          <v-row>
            <v-col cols="9">
              <v-text-field
                label="Enter your email address"
                dense
                hide-details
                variant="solo"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="d-flex align-center">
              <v-btn color="white" class="white--text" rounded>
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Bottom Footer Section -->
      <v-divider class="my-4" color="#45009fff"></v-divider>
      <v-row justify="center" class="my-4">
        <p style="color: #45009fff">
          © {{ new Date().getFullYear() }} Workforce — Property Services, Inc.
        </p>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        { title: "mdi-facebook", color: "#45009fff" },
        { title: "mdi-twitter", color: "#45009fff" },
        { title: "mdi-linkedin", color: "#45009fff" },
        { title: "mdi-instagram", color: "#45009fff" },
      ],
      faqs: [
        "Consectetur adipiscing elit?",
        "Integer cursus turpis ut sem laoreet?",
        "Dolor sit amet consectetur?",
      ],
    };
  },
};
</script>
